// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__2TVhz","loginContainer":"login_loginContainer__qEFiN","logoImage":"login_logoImage__cfaWU"};